import { useState, useEffect } from 'react';
import { ResetPasswordPage } from './auth/ResetPasswordPage';
import { DesktopResetPasswordPage } from './desktop/DesktopResetPasswordPage';

export function ResponsiveResetPasswordPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <ResetPasswordPage /> : <DesktopResetPasswordPage />;
}